import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

import FanzoneRecommend from '../FanzoneRecommend/FanzoneRecommend';

import './CheckoutSuccess.css';


function CheckoutSuccess(props) {
  const queryParams = qs.parse(props.location.search, { ignoreQueryPrefix: true });
  const { shippingName, shippingAddress, shippingRegionCode, shippingZipCode, shippingCountryCode, shippingCity } = queryParams;

  return (
    <div className="calendar-checkout-container">
      <h1 className="calendar-checkout-title">SUCCESS!</h1>
      <p className="calendar-checkout-text">
        We'll ship your calendar in 7 to 10 business days. You will receive a notification once your package is shipped to:
      </p>
      <div className="success-details">
        {shippingName}
      </div>
      <div className="success-details">{shippingAddress} {shippingCity}</div>
      <div className="success-details">{shippingRegionCode} {shippingZipCode} {shippingCountryCode}</div>
      <p className="calendar-checkout-text">
        Please note that any inconsistency in the shipping details can result in additional delivery time and/or increased shipping fees. If the address above is incorrect please <a href="/contact">contact us</a> to fix it before the product is shipped
      </p>
      <FanzoneRecommend anchorId={props.anchorId} />
    </div >
  );
}

CheckoutSuccess.propTypes = { location: PropTypes.object.isRequired };

export default CheckoutSuccess;
